export const parseApiMoney = (value = '0'): number => parseInt(value, 10)
